export const PLAY_URL = "https://play.google.com/store/apps/details?id=com.myfreshtracker.app&pli=1";
export const APPSTORE_URL = "https://apps.apple.com/ca/app/my-fresh-tracker/id6814677216";

export default function StoreBadges({ idPrefix = "store", className = "" }) {
  return (
    <div className={`flex items-center gap-3 md:gap-4 ${className}`} data-testid={`${idPrefix}-store-badges`}>
      <a
        href={APPSTORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`${idPrefix}-badge-app-store`}
        className="transition-transform duration-300 hover:scale-105"
      >
        <img src="/badges/app-store.svg" alt="Download on the App Store" className="h-12 md:h-14 w-auto" />
      </a>
      <a
        href={PLAY_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`${idPrefix}-badge-google-play`}
        className="h-12 md:h-14 overflow-hidden flex items-center transition-transform duration-300 hover:scale-105"
      >
        <img src="/badges/google-play.png" alt="Get it on Google Play" className="h-[4.5rem] md:h-[5.25rem] w-auto" />
      </a>
    </div>
  );
}
